/**
 *  페이지 이름
 */
export const NOTICE_STORE_PAGE_NAME = {
  NOTICE_STORE_CREATE: '상점 공지사항 등록',
  NOTICE_STORE_EDIT: '상점 공지사항 편집',
  NOTICE_STORE_LIST: '상점 공지사항 리스트',
};

/**
 *  상점 공지사항 타입
 */
export const NOTICE_STORE_TYPE = {
  /**
   *  일반
   */
  GENERAL: 0,
  /**
   *  시스템
   */
  SYSTEM: 1,
  /**
   *  메뉴얼
   */
  MANUAL: 2,
  /**
   *  FAQ
   */
  FAQ: 3,
  /**
   *  풀필먼트
   */
  FULFILLMENT: 4,
};

/**
 *  상점 공지사항 타입 이름
 */
export const NOTICE_STORE_TYPE_TEXT = {
  [NOTICE_STORE_TYPE.GENERAL]: '일반',
  [NOTICE_STORE_TYPE.SYSTEM]: '시스템',
  [NOTICE_STORE_TYPE.MANUAL]: '매뉴얼',
  [NOTICE_STORE_TYPE.FAQ]: 'FAQ',
  [NOTICE_STORE_TYPE.FULFILLMENT]: '풀필먼트',
};

/**
 *  상점 공지사항 타입 SELECT 리스트
 */
export const NOTICE_STORE_TYPE_SELECT_LIST = [
  {
    id: NOTICE_STORE_TYPE.GENERAL,
    name: NOTICE_STORE_TYPE_TEXT[NOTICE_STORE_TYPE.GENERAL],
  },
  {
    id: NOTICE_STORE_TYPE.SYSTEM,
    name: NOTICE_STORE_TYPE_TEXT[NOTICE_STORE_TYPE.SYSTEM],
  },
  {
    id: NOTICE_STORE_TYPE.MANUAL,
    name: NOTICE_STORE_TYPE_TEXT[NOTICE_STORE_TYPE.MANUAL],
  },
  {
    id: NOTICE_STORE_TYPE.FAQ,
    name: NOTICE_STORE_TYPE_TEXT[NOTICE_STORE_TYPE.FAQ],
  },
  {
    id: NOTICE_STORE_TYPE.FULFILLMENT,
    name: NOTICE_STORE_TYPE_TEXT[NOTICE_STORE_TYPE.FULFILLMENT],
  },
];

/**
 *  상점 공지사항 상태
 */
export const NOTICE_STORE_STATUS = {
  /**
   *  비 노출
   */
  NON_EXPOSURE: 0,
  /**
   *  노출
   */
  EXPOSURE: 1,
  /**
   *  삭제
   */
  DELETE: 2,
};

/**
 *  상점 공지사항 상태 TEXT
 */
export const NOTICE_STORE_STATUS_TEXT = {
  0: '비 노출',
  1: '노출',
};

/**
 *  상점 공지사항 상태 SELECT 리스트
 */
export const NOTICE_STORE_STATUS_SELECT_LIST = [
  {
    id: 0,
    name: '비 노출',
  },
  {
    id: 1,
    name: '노출',
  },
];

/**
 *  상점 공지사항 홈 노출 여부 상태
 */
export const NOTICE_STORE_HOME_EXPOSURE_STATUS = {
  /**
   *  비 노출
   */
  NON_EXPOSURE: 0,
  /**
   *  노출
   */
  EXPOSURE: 1,
};

/**
 *  상점 공지사항 홈 노출 여부 상태 TEXT
 */
export const NOTICE_STORE_HOME_EXPOSURE_STATUS_TEXT = {
  0: '비 노출',
  1: '노출',
};

/**
 *  상점 공지사항 홈 노출 여부 상태 SELECT 리스트
 */
export const NOTICE_STORE_HOME_EXPOSURE_STATUS_SELECT_LIST = [
  {
    id: 0,
    name: '비 노출',
  },
  {
    id: 1,
    name: '노출',
  },
];

/**
 *  상점 공지사항이 없을 때 보여주는 텍스트
 */
export const BALANCE_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 상점 공지사항 리스트가 없습니다.';
